module.exports = __webpack_public_path__ + "img/MetalArmor.1a88484e.gif";